import styled from '@emotion/styled';
import tw from 'twin.macro';
import AnchorHeading from '../AnchorHeader/AnchorHeader';

export const StyledHeadline = styled(AnchorHeading)`
  ${tw`font-poppins font-semi-bold`}
  ${tw`text-mobile-heading-l md:text-display-xl text-secondary-s1 text-left`}
  ${tw`mb-3`}
`;

export const StyledAccordionSection = styled.section`
  ${tw`container`}
  ${tw`container-stack-context`}
  ${tw`grid grid-cols-1 md:grid-cols-12`}
  ${tw`px-2 md:px-0`}
`;

export const StyledContainer = styled.div`
  ${tw`md:col-span-8 md:col-start-3`}
`;

export const StyledAccordionWrapper = styled.section<{ backgroundColor?: string }>`
  ${({ backgroundColor }) =>
    backgroundColor === 'pink' ? tw`bg-ui-colours-ui1` : tw`bg-transparent`}
`;
